import { render, staticRenderFns } from "./EditableFieldWithDefault.vue?vue&type=template&id=2d40720f&"
import script from "./EditableFieldWithDefault.vue?vue&type=script&lang=ts&"
export * from "./EditableFieldWithDefault.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports